module.exports = __webpack_public_path__ + "static/media/comment-svgrepo-com (4).6130397f.svg";